import styled, { css } from 'styled-components';
import { DismissRegular } from '@fluentui/react-icons';

const FilterTagContentCommon = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const FilterTagsWrapper = styled.div`
  display: grid;
  grid-template-columns: max-content 1fr;
  grid-template-rows: auto;
  grid-template-areas: 'clearAllTags scrollableTags';
  align-items: center;
  gap: 8px;
`;

export const ClearAllTagsContent = styled.div`
  grid-area: clearAllTags;
  ${FilterTagContentCommon}
`;

export const FilterTagsScrollableWrapper = styled.div`
  grid-area: scrollableTags;
  display: flex;
  flex-direction: row;
  width: 100%;
  overflow-x: auto;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Tags = styled.div`
  display: flex;
  flex-direction: row;
`;

export const FilterTag = styled.div`
  border: 1px solid ${(props) => props.theme.calendarDividerColor};
  border-radius: 99px;
  padding: 1px 12px;
  margin: 0 4px;
`;
export const FilterTagContent = styled.div`
  ${FilterTagContentCommon};
`;

export const FilterLabel = styled.span`
  white-space: nowrap;
  color: ${(props) => props.theme.primaryButtonBackgroundHover};
  cursor: pointer;
  font-weight: 600;
`;

export const DismissIcon = styled(DismissRegular)`
  cursor: pointer;
  font-weight: 600;
  font-size: 16px;
  min-width: 16px;
`;
